import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeneStatsComponent } from './gene-stats.component';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  Shell.publicRoutes([{ path: 'gene-stats', component: GeneStatsComponent, data: { title: 'Gene Stats' } }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeneStatsRoutingModule {}
